<template>
  <div class="owner-committee-detail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('ownerCommitteeDetail.title')" :subtitle="$t('ownerCommitteeDetail.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 基本信息面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('ownerCommitteeDetail.page.infoTitle') }}</span>
      </div>
      <div class="ds-info-grid">
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.name') }}</span>
          <span class="ds-info-grid__value">{{ ownerCommitteeDetailInfo.name || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.sex') }}</span>
          <span class="ds-info-grid__value">
            {{ ownerCommitteeDetailInfo.sex == 'B' ? $t('common.male') : $t('common.female') }}
          </span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.link') }}</span>
          <span class="ds-info-grid__value ds-num">{{ ownerCommitteeDetailInfo.link || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.idCard') }}</span>
          <span class="ds-info-grid__value ds-num">{{ ownerCommitteeDetailInfo.idCard || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.address') }}</span>
          <span class="ds-info-grid__value">{{ ownerCommitteeDetailInfo.address || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.position') }}</span>
          <span class="ds-info-grid__value">{{ ownerCommitteeDetailInfo.position || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.post') }}</span>
          <span class="ds-info-grid__value">{{ ownerCommitteeDetailInfo.post || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.postDesc') }}</span>
          <span class="ds-info-grid__value">{{ ownerCommitteeDetailInfo.postDesc || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.appointTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ ownerCommitteeDetailInfo.appointTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.curTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ ownerCommitteeDetailInfo.curTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.state') }}</span>
          <span class="ds-info-grid__value">
            <ds-status-tag
              :label="ownerCommitteeDetailInfo.state == '1000' ? $t('addOwnerCommittee.onJob') : $t('addOwnerCommittee.leaveJob')"
              :text="ownerCommitteeDetailInfo.state == '1000' ? $t('addOwnerCommittee.onJob') : $t('addOwnerCommittee.leaveJob')"
              :type="ownerCommitteeDetailInfo.state == '1000' ? 'success' : 'info'" />
          </span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('ownerCommitteeDetail.remark') }}</span>
          <span class="ds-info-grid__value">{{ ownerCommitteeDetailInfo.remark || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- (3)(4) 紧急联系人面板 + 表格 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('ownerCommitteeDetail.emergencyContacts') }}</span>
      </div>

      <ds-data-table :data="ownerCommitteeDetailInfo.contracts" :loading="loading" :error="hasError"
        :error-message="errorMessage" density="default" border
        :empty-description="$t('ownerCommitteeDetail.page.empty')" @retry="getOwnerCommitteeContracts">
        <el-table-column prop="relName" :label="$t('ownerCommitteeDetail.memberRelation')" align="center" min-width="120" />
        <el-table-column prop="name" :label="$t('ownerCommitteeDetail.name')" align="center" min-width="110" />
        <el-table-column prop="link" :label="$t('ownerCommitteeDetail.contactPhone')" align="center" width="130">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.link || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" :label="$t('ownerCommitteeDetail.address')" align="center" min-width="180"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.address || '-' }}
          </template>
        </el-table-column>
      </ds-data-table>
    </div>
  </div>
</template>

<script>
import { getOwnerCommitteeDetail, listOwnerCommitteeContracts } from '@/api/owner/ownerCommitteeDetailApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'OwnerCommitteeDetailList',
  components: {
    DsPageHeader,
    DsDataTable,
    DsStatusTag
  },
  data() {
    return {
      ownerCommitteeDetailInfo: {
        ocId: '',
        name: '',
        sex: '',
        link: '',
        idCard: '',
        address: '',
        position: '',
        post: '',
        postDesc: '',
        appointTime: '',
        curTime: '',
        state: '',
        remark: '',
        contracts: [],
        communityId: ''
      },
      loading: false,
      hasError: false,
      errorMessage: ''
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.ownerCommitteeDetailInfo.ocId = this.$route.query.ocId
      this.ownerCommitteeDetailInfo.communityId = getCommunityId()
      this.getOwnerCommitteeDetail()
      this.getOwnerCommitteeContracts()
    },
    async getOwnerCommitteeDetail() {
      try {
        this.loading = true
        this.hasError = false
        this.errorMessage = ''
        const params = {
          page: 1,
          row: 1,
          communityId: this.ownerCommitteeDetailInfo.communityId,
          ocId: this.ownerCommitteeDetailInfo.ocId
        }
        const res = await getOwnerCommitteeDetail(params)
        if (res.data && res.data.length > 0) {
          Object.assign(this.ownerCommitteeDetailInfo, res.data[0])
        }
      } catch (error) {
        this.hasError = true
        this.errorMessage = this.$t('ownerCommitteeDetail.fetchDetailError')
      } finally {
        this.loading = false
      }
    },
    async getOwnerCommitteeContracts() {
      try {
        this.loading = true
        this.hasError = false
        this.errorMessage = ''
        const params = {
          page: 1,
          row: 100, // 获取所有紧急联系人
          communityId: this.ownerCommitteeDetailInfo.communityId,
          ocId: this.ownerCommitteeDetailInfo.ocId
        }
        const res = await listOwnerCommitteeContracts(params)
        this.ownerCommitteeDetailInfo.contracts = res.data || []
      } catch (error) {
        this.hasError = true
        this.errorMessage = this.$t('ownerCommitteeDetail.fetchContactsError')
      } finally {
        this.loading = false
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.owner-committee-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }
}

/* 面板标题栏 */
.ds-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--ds-spacing-md);
  margin-bottom: var(--ds-spacing-lg);
  border-bottom: 1px solid var(--ds-gray-200);
}

.ds-panel__title {
  font-size: var(--ds-font-size-lg);
  font-weight: 600;
  color: var(--ds-gray-800);
}
</style>
